// extracted by mini-css-extract-plugin
export default {"header":"Header_header__s4ywa","logo":"Header_logo__bsn9z","nav":"Header_nav__GvVPd","hamburger":"Header_hamburger__MUlgj","open":"Header_open__c4eII","show":"Header_show__7SZHl"};